import React, { useState, useEffect } from 'react';

const AdminNewsletterSignups = ({ password }) => {
  const [signups, setSignups] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchSignups = async () => {
      setLoading(true);
      setError('');
      try {
        const res = await fetch('/api/admin_newsletter_signups', {
          headers: { 'x-admin-password': password },
        });
        if (res.status === 401) {
          setError('Incorrect password.');
          setLoading(false);
          return;
        }
        if (!res.ok) throw new Error('Failed to fetch signups');
        const data = await res.json();
        setSignups(data.signups);
      } catch (err) {
        setError('Error fetching newsletter signups.');
      } finally {
        setLoading(false);
      }
    };
    if (password) fetchSignups();
  }, [password]);

  if (loading) return <div>Loading newsletter signups...</div>;
  if (error) return <div style={{ color: 'red' }}>{error}</div>;

  return (
    <div style={{ maxWidth: 900, margin: '2rem auto', padding: 20 }}>
      <h2>Newsletter Signups</h2>
      {signups.length === 0 ? (
        <div>No signups found.</div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid #ccc', padding: 8 }}>Timestamp</th>
                <th style={{ border: '1px solid #ccc', padding: 8 }}>Name</th>
                <th style={{ border: '1px solid #ccc', padding: 8 }}>Email</th>
              </tr>
            </thead>
            <tbody>
              {signups.map((s, i) => (
                <tr key={i}>
                  <td style={{ border: '1px solid #ccc', padding: 8 }}>{s.timestamp || ''}</td>
                  <td style={{ border: '1px solid #ccc', padding: 8 }}>{s.name || ''}</td>
                  <td style={{ border: '1px solid #ccc', padding: 8 }}>{s.email || (s.invalid ? '[Invalid Entry]' : '')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminNewsletterSignups; 